

<template>
    {{ phoneFormat(Phone) }}
</template>

<script setup>

const props = defineProps({
    Phone: {
    type: String,
    required: true,
  }
});

const phoneFormat = ((phone) => {
      if(phone == null || phone == ""){
        return "0xxx-xxxxxx"
      }
      var first = phone.slice(0, 4)
      var last = phone.slice(-6)
      return first+'-'+last
    })


</script>
